const PARALLAX_SPEED = 0.05;

export default class Parallax {
    constructor() {
        this.$parallaxes = [...document.querySelectorAll('.js-parallax')];
        this.updateParallax = this.updateParallax.bind(this);
    }

    updateParallax() {
        for (const $parallax of this.$parallaxes) {
            const { top } = $parallax.getBoundingClientRect();
            const translateY = top * PARALLAX_SPEED;
            $parallax.style.translate = `0 ${-translateY}px`;
        }

        requestAnimationFrame(this.updateParallax);
    }
}
